export const toSorted = <T>(
  array: T[],
  compareFn: (a: T, b: T) => number,
): T[] => [...array].sort(compareFn);
